import { Link } from 'react-router-dom'
import { SEO } from '@/components/SEO'

export function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." />
      <section className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
        <p className="text-primary font-mono text-sm tracking-widest uppercase">404</p>
        <h1 className="text-fluid-h1 text-foreground mt-4">This page hasn&apos;t been built</h1>
        <p className="text-fluid-body-lg text-muted-foreground mx-auto mt-4 max-w-xl">
          The page you&apos;re looking for moved, was renamed, or never existed. Let&apos;s get you back on track.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/"
            className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-6 py-3 text-sm font-semibold transition-colors"
          >
            Back to home
          </Link>
          <Link to="/portfolio" className="text-primary text-sm font-semibold underline underline-offset-4">
            View the portfolio
          </Link>
        </div>
      </section>
    </>
  )
}
